import { Message } from '@chatscope/chat-ui-kit-react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import { AppBar, Badge, Button, Dialog, Fab, IconButton, Link, Toolbar, Typography, useMediaQuery } from '@material-ui/core';
import { AttachFile, ChatBubble, Close } from '@material-ui/icons';

import isEmpty from 'lodash.isempty';
import moment from "moment-timezone";
import { useCallback, useEffect, useMemo } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useUserState } from 'services/authentication.service';
import { registerProviderChat, registerSupportChat } from 'services/chat.services';
import { canMessage } from 'util/bookingStates';
import { personNameFull } from 'util/format';
import { useState } from 'util/stateref';
import { chatChannelState, CLOSE_CHAT, medicalChatChannelState, MEDICAL_CHAT, openChatState, providerChatChannelState, PROVIDER_CHAT, SUPPORT_CHAT, activeUserState, isJourneyVisibleState } from 'pages/CustomerBooking';
import { bookingState, clientState } from '../RecoilState';
import SupportChatWorker from './chat.worker.js';
import { MedicalChat } from './MedicalChat';
import MedicalChatWorker from './medicalchat.worker';
import { ProviderChat } from './ProviderChat';
import ProviderChatWorker from './providerchat.worker.js';
import { useStyles } from './styles';
import { SupportChat } from './SupportChat';
import { useTrackEvent } from 'util/trackEvent';
import { useStateRef, useUrlState } from '@zennya/web-component-library/src';
import { fingerprintState } from 'util/deviceUUID';
import clsx from 'clsx';
import useDocumentHeight from 'util/useDocumentHeight';

let providerPollWorker = new ProviderChatWorker()
let medicalPollWorker = new MedicalChatWorker()
let chatPollWorker = new SupportChatWorker()


const Chat = ({ disableMedical = false, isAnonymous = false, serviceId, source = "Whitelabel" }) => {
  const classes = useStyles()

  const [disabled, setDisabled] = useState(false);
  const clientStatus = useRecoilValue(clientState)

  const chatOpen = useRecoilValue(openChatState);
  const setChatOpen = useSetRecoilState(openChatState);

  const conversationId = useRecoilValue(providerChatChannelState);
  const setConversationId = useSetRecoilState(providerChatChannelState);

  const [fingerprint, setFingerprint] = useRecoilState(fingerprintState)

  const { user, getUser } = useUserState()
  const [userState, setUserState, userStateRef] = useState();

  const [supportUnreadCount, setSupportUnreadCount] = useState(0);
  const [supportMessageList, setSupportMessageList] = useState([]);

  const [medicalUnreadCount, setMedicalUnreadCount] = useState(0);
  const [medicalMessageList, setMedicalMessageList] = useState([]);

  const [providerUnreadCount, setProviderUnreadCount] = useState(0);
  const [providerMessageList, setProviderMessageList] = useState([]);

  const channelState = useRecoilValue(chatChannelState);
  const setChannelState = useSetRecoilState(chatChannelState);
  const medicalChannelState = useRecoilValue(medicalChatChannelState);
  const setMedicalChannelState = useSetRecoilState(medicalChatChannelState);
  const activeUser = useRecoilValue(activeUserState)
  const [isJourneyVisible, setIsJourneyVisible] = useRecoilState(isJourneyVisibleState);

  const [openChatByUrl, setOpenChatByUrl] = useUrlState({
    queryKey: 'chat',
    defaultValue: ''
  })

  useEffect(
    () => {
      if ([SUPPORT_CHAT, MEDICAL_CHAT, PROVIDER_CHAT].includes(openChatByUrl)) {
        setChatOpen(openChatByUrl)
        setOpenChatByUrl('')
      }
    }, [openChatByUrl]
  );

  useEffect(
    () => {
      console.log(chatOpen)
    }, [chatOpen]
  );
  const [supportChatReloadKey, setSupportChatReloadKey] = useState(0);
  const [medicalChatReloadKey, setMedicalChatReloadKey] = useState(0);
  const [providerChatReloadKey, setProviderChathatReloadKey] = useState(0);

  const booking = useRecoilValue(bookingState)

  const trackEvent = useTrackEvent(serviceId)

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });

  //register
  useMemo(async () => {
    if (clientStatus?.appointment?.id) {
      const user = await getUser(serviceId)
      setUserState(user)
      const result = await registerProviderChat(clientStatus?.appointment?.id)
      setConversationId(result)
    } else if (booking?.appointment?.id) {
      const user = await getUser(serviceId)
      setUserState(user)
      const result = await registerProviderChat(booking?.appointment?.id)
      setConversationId(result)
    }
  }, [clientStatus?.appointment?.id, getUser, setConversationId, setUserState, booking]);

  useEffect(() => {
    if (!providerPollWorker) providerPollWorker = new ProviderChatWorker();
    return () => {
      console.log('UEF:onterminate');
      providerPollWorker?.terminate();
      providerPollWorker = null
    };
  }, []);

  useEffect(() => {
    if (providerPollWorker && conversationId) {
      providerPollWorker.postMessage({ token: user?.token, conversationId });
    }
  }, [conversationId, user?.token, providerChatReloadKey]);


  const processProviderPoll = useCallback(
    async (message) => {
      const mappedMessages = message?.data?.messageList?.list?.filter(
        (v, i, a) => a.findIndex((t) => t.id === v.id) === i
      ).map(message => {
        let payload = null

        const sentTime = moment(message.timestamp).fromNow()

        return {
          message: message?.content,
          sentTime,
          sender: message?.provider ? personNameFull(message?.provider) : 'me',
          direction: message?.client ? 'outgoing' : 'incoming',
          position: "single",
          avatar: message?.provider?.avatar_url,
          payload
        }
      })
      setProviderMessageList(mappedMessages)
    },
    [],
  );


  useEffect(() => {
    providerPollWorker.onmessage = message => {
      processProviderPoll(message)
    }
  }, [processProviderPoll]);


  //medical
  useEffect(async () => {
    if (!isEmpty(fingerprint) && chatOpen === MEDICAL_CHAT) {
      if (medicalChannelState) return
      const user = await getUser(serviceId)
      setUserState(user)
      if (!isEmpty(user)) {
        setDisabled(false)
        try {
          const result = await registerSupportChat(fingerprint, true)
          setMedicalChannelState(result)
        } catch (error) {
          setDisabled(error?.message)
        }
      }
    }
  }, [fingerprint, getUser, setMedicalChannelState, setUserState, chatOpen]);

  useEffect(() => {
    if (!medicalPollWorker) medicalPollWorker = new MedicalChatWorker();
    return () => {
      console.log('UEF:onterminate');
      medicalPollWorker?.terminate();
      medicalPollWorker = null
    };
  }, []);

  useEffect(() => {
    if (medicalPollWorker && fingerprint) {
      medicalPollWorker.postMessage({ token: activeUser?.token, pageSize: 10, fingerprint: fingerprint });
    }
  }, [fingerprint, activeUser?.token, medicalChatReloadKey]);


  const processMedicalPoll = useCallback(
    async (message) => {
      setSupportUnreadCount(message?.data?.unreadCount?.unread_count)

      const mappedMessages = message?.data?.messageList?.list?.filter(
        (v, i, a) => a.findIndex((t) => t.id === v.id) === i
      ).map(message => {
        let payload = null

        const sentTime = moment(message.timestamp).fromNow()
        if (!isEmpty(message?.attachments)) {
          payload = <Message.CustomContent>
            {message?.text}
            <br />
            {message?.attachments?.map((attachment, index) => {
              if (attachment?.mime_type.startsWith('image')) {
                return <Message.ImageContent className={classes.imageAttach} key={index} src={attachment?.preview_url} />
              } else {
                return <Message.CustomContent>
                  <a rel="noreferrer" className={classes.linkAttachment} target="_blank" color="inherit" href={attachment?.url}><AttachFile fontSize='small' />{attachment?.name}</a>
                </Message.CustomContent>
              }
            })}
          </Message.CustomContent>

        }
        return {
          message: message.text,
          sentTime,
          sender: message?.variant?.sender?.display_name,
          direction: message?.variant?.type === "INCOMING" ? 'outgoing' : 'incoming',
          position: "single",
          avatar: message?.variant?.sender?.avatar_url,
          payload
        }
      })
      setMedicalMessageList(mappedMessages.reverse())
    },
    [],
  );

  useEffect(() => {
    medicalPollWorker.onmessage = message => {
      processMedicalPoll(message)
    }
  }, [processMedicalPoll]);

  //support
  useEffect(() => {
    const fn = async () => {
      if (!isEmpty(fingerprint) && chatOpen === SUPPORT_CHAT) {
        if (channelState) return
        const user = await getUser(serviceId)
        setUserState(user)

        setDisabled(false)
        try {
          const result = await registerSupportChat(fingerprint)
          setMedicalChannelState(result)
        } catch (error) {
          setDisabled(error?.message)
        }
        initWorker()
      }
    }
    fn()
  }, [fingerprint, chatOpen]);

  const [existingSupportToken, setExistingSupportToken, existingSupportTokenRef] = useStateRef(null);
  useEffect(() => {
    if (!chatPollWorker) chatPollWorker = new SupportChatWorker();
    return () => {
      console.log('UEF:onterminate');
      chatPollWorker?.terminate();
      chatPollWorker = null
    };
  }, []);

  const initWorker = useCallback(
    async () => {
      if (existingSupportTokenRef.current !== activeUser?.token) {
        setExistingSupportToken(activeUser?.token)
        chatPollWorker?.terminate()
        medicalPollWorker?.terminate()
        medicalPollWorker = new MedicalChatWorker()
        chatPollWorker = new SupportChatWorker()

        medicalPollWorker.onmessage = message => {
          processMedicalPoll(message)
        }
        chatPollWorker.onmessage = message => {
          processSupportPoll(message)
        }
      }
      if (chatPollWorker && fingerprint) {
        chatPollWorker.postMessage({ token: activeUser?.token, pageSize: 10, fingerprint: fingerprint });
      }
    },
    [chatPollWorker, fingerprint, activeUser],
  );

  useEffect(() => {

    initWorker()
  }, [supportChatReloadKey, activeUser?.token]);

  const processSupportPoll = useCallback(
    async (message) => {
      setSupportUnreadCount(message?.data?.unreadCount?.unread_count)

      const mappedMessages = message?.data?.messageList?.list?.filter(
        (v, i, a) => a.findIndex((t) => t.id === v.id) === i
      ).map(message => {
        let payload = null

        const sentTime = moment(message.timestamp).fromNow()
        if (!isEmpty(message?.attachments)) {
          payload = <Message.CustomContent>
            {message?.text}
            <br />
            {message?.attachments?.map((attachment, index) => {
              if (attachment?.mime_type.startsWith('image')) {
                return <Message.ImageContent className={classes.imageAttach} key={index} src={attachment?.preview_url} />
              } else {
                return <Message.CustomContent>
                  <Link rel="noreferrer" className={classes.linkAttachment} target="_blank" color="initial" href={attachment?.url}><AttachFile fontSize='small' />{attachment?.name}</Link>
                </Message.CustomContent>
              }
            })}
          </Message.CustomContent>

        }
        return {
          message: message.text,
          sentTime,
          sender: message?.variant?.sender?.display_name,
          direction: message?.variant?.type === "INCOMING" ? 'outgoing' : 'incoming',
          position: "single",
          avatar: message?.variant?.sender?.avatar_url,
          payload
        }
      })
      setSupportMessageList(mappedMessages.reverse())
    },
    [],
  );

  useEffect(() => {
    chatPollWorker.onmessage = message => {
      processSupportPoll(message)
    }
  }, [processSupportPoll]);

  const renderAppBar = useMemo(() => {
    return (
      <AppBar position="relative" color="default" elevation={0}>
        {isJourneyVisible && <div className={classes.offsetTop} />}
        <Toolbar variant="dense">
          <IconButton edge="start" color="inherit" onClick={() => {
            trackEvent(`Chat - close chat `, { type: 'close button' })
            setChatOpen(CLOSE_CHAT)
          }} aria-label="close">
            <Close />
          </IconButton>
          {canMessage(null, clientStatus) && (
            <Button className={classes.toolbarButton} size="small" variant={chatOpen === PROVIDER_CHAT ? 'contained' : 'text'} color="primary" onClick={() => {
              trackEvent(`Chat - changeTab - ${PROVIDER_CHAT}`, {})
              setChatOpen(PROVIDER_CHAT)
            }}>
              Provider Chat
            </Button>
          )}
          <Button className={classes.toolbarButton} size="small" variant={(chatOpen === SUPPORT_CHAT || chatOpen === MEDICAL_CHAT) ? 'contained' : 'text'} color="primary" onClick={() => {
            trackEvent(`Chat - changeTab - ${SUPPORT_CHAT}`, {})
            setChatOpen(SUPPORT_CHAT)
          }}>
            Support Chat
          </Button>
        </Toolbar>
        {(chatOpen === SUPPORT_CHAT || chatOpen === MEDICAL_CHAT) && (
          <>
            {!disableMedical && (
              <Toolbar variant="dense" disableGutters className={classes.hasDivider}>
                <Button className={classes.toolbarButton} size="small" variant={chatOpen === SUPPORT_CHAT ? 'contained' : 'text'} color="primary" onClick={() => {
                  trackEvent(`Chat - changeTab - ${SUPPORT_CHAT}`, {})
                  setChatOpen(SUPPORT_CHAT)
                }}>
                  General Chat
                </Button>
                <Button className={classes.toolbarButton} size="small" variant={chatOpen === MEDICAL_CHAT ? 'contained' : 'text'} color="primary" onClick={() => {
                  trackEvent(`Chat - changeTab - ${MEDICAL_CHAT}`, {})
                  setChatOpen(MEDICAL_CHAT)
                }}>
                  Medical Chat
                </Button>
              </Toolbar>
            )}
          </>
        )}
      </AppBar>
    )
  }, [chatOpen, clientStatus, disableMedical, isJourneyVisible]);

  const renderChatComponent = useMemo(() => {
    if (disabled) {
      return <div className={classes.disabledChat}>
        <Typography variant="h6" color="inherit" align="center">
          {disabled}
        </Typography>
      </div>
    }
    if (chatOpen === SUPPORT_CHAT && !isEmpty(fingerprint)) {
      return <SupportChat source={source} fingerprint={fingerprint} messageList={supportMessageList} reloadMessages={() => setSupportChatReloadKey(Math.random())}
        appBar={renderAppBar}
      />
    }
    if (chatOpen === MEDICAL_CHAT && !isEmpty(fingerprint)) {
      return <MedicalChat source={source} fingerprint={fingerprint} messageList={medicalMessageList} reloadMessages={() => setMedicalChatReloadKey(Math.random())}
        appBar={renderAppBar}
      />
    }
    if (chatOpen === PROVIDER_CHAT) {
      return <ProviderChat source={source} messageList={providerMessageList} reloadMessages={() => setProviderChathatReloadKey(Math.random())}
        appBar={renderAppBar}
      />
    }
    return <SupportChat source={source} fingerprint={fingerprint} messageList={supportMessageList} reloadMessages={() => setSupportChatReloadKey(Math.random())}
      appBar={renderAppBar}
    />
  }, [renderAppBar, chatOpen, fingerprint, medicalMessageList, providerMessageList, supportMessageList]);

  const webkitHeight = useDocumentHeight()
  return (
    <>
      {!(isMobile) && (
        <Badge className={classes.fab} color="primary">
          <Fab color="secondary"
            variant={chatOpen === CLOSE_CHAT ? "extended" : "circular"}
            onClick={() => {
              if (chatOpen !== CLOSE_CHAT) {
                trackEvent('Chat Floating Bubble - clicked', { 'open': false, 'type': SUPPORT_CHAT })
                setChatOpen(CLOSE_CHAT)
              } else {
                trackEvent('Chat Floating Bubble - clicked', { 'open': true, 'type': SUPPORT_CHAT })
                setChatOpen(SUPPORT_CHAT)
              }
            }}><ChatBubble />{chatOpen === CLOSE_CHAT ? "Support Chat" : ""}</Fab>
        </Badge>
      )}
      <Dialog
        className={classes.chatRoot}
        // style={{
        //   height: `${webkitHeight}px`
        // }}
        keepMounted
        fullScreen={isMobile}
        open={chatOpen !== CLOSE_CHAT}
        onClose={() => {
          trackEvent('Chat - close chat ', { type: 'dismiss dialog' })
          setChatOpen(CLOSE_CHAT)
        }}
        scroll="paper"
        classes={{
          scrollPaper: classes.bottomScrollPaper,
          paperScrollBody: classes.bottomScrollBody,
          paperScrollPaper: classes.paperScrollPaper,
        }}
      >
        {chatOpen === CLOSE_CHAT ? <></> : (
          <>
            {renderChatComponent}
          </>
        )}

      </Dialog>
    </>
  )
}

export { Chat };
